import React from 'react';
export function Footer() {
  return <footer className="bg-background py-8 border-t border-border" data-id="element-56">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6 text-center md:text-left" data-id="element-57">
        <div className="flex flex-col gap-1" data-id="element-58">
          <div className="text-xl font-semibold tracking-tight text-primary" data-id="element-59">
            Вікторія
          </div>
          <div className="text-sm text-secondary" data-id="element-60">
            Бухгалтер для ФОП · Працюю дистанційно по всій Україні
          </div>
        </div>

        <div className="flex flex-col items-center md:items-end gap-1" data-id="element-61">
          <a href="tel:+380632562477" className="text-primary font-medium hover:opacity-80 transition-opacity" data-id="element-62">
            +38 (063) 256-24-77
          </a>
          <div className="text-sm text-secondary" data-id="element-63">
            &copy; {new Date().getFullYear()} Всі права захищені.
          </div>
        </div>
      </div>
    </footer>;
}